import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { FuseSharedModule } from '@fuse/shared.module';

import { QuickPanelComponent } from 'app/layout/components/quick-panel/quick-panel.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
    declarations: [
        QuickPanelComponent
    ],
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,

    FuseSharedModule,
    NgxPermissionsModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
  ],
    exports: [
        QuickPanelComponent
    ]
})
export class QuickPanelModule
{
}
